
import { READING_RANK } from 'lib/const';
import { useSelector } from 'react-redux';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { ErrorMessageBox } from 'bf-library';
import { Loading } from 'app/components/Loading';

export const CertificateList = ({appleCertificate=null, onToggleCertificate=f=>f}) => {
  const auth = useSelector(state => state.auth);

  const { data:appleCert, isLoading, isError, error } = useQuery({
      queryKey: ['user/apple/certificate'],
      queryFn: () => Api.get('/api/book/apple/certificate')
  });
  
    
  if ( isLoading ) return <Loading />;
  if ( isError ) return <ErrorMessageBox message={createFetchErrorMessage(error).message} />;


  let years = new Array(6).fill().map((_, idx) => Number(auth.createdAt?.substr(0, 4)) + idx);
  
  return years.map((year) => {
    let certificate = appleCert?.data?.find((cert) => Number(cert.year) === year);

    if (certificate === undefined || certificate.grade === 7) {
      return (
        <div key={year}>
            <span className="year">{year}</span>
        </div>
      );
    };
  
    let rank = READING_RANK.find((rank) => rank.startNum <= certificate.totalCount);

    return (
      <div className={`${Number(appleCertificate?.year) === year ? "on" : ""}`} onClick={(e) => onToggleCertificate(certificate)} key={year}>
          <img src={`${process.env.PUBLIC_URL}/static/images/user/b0${rank.rank}.png`} alt={rank.name} key="rankImage" />
          <span className="year">
              {year}
          </span>
      </div>
    );
});
};